import { render, staticRenderFns } from "./FeedContentNewRegistration.vue?vue&type=template&id=6ae8273f&scoped=true"
import script from "./FeedContentNewRegistration.vue?vue&type=script&lang=js"
export * from "./FeedContentNewRegistration.vue?vue&type=script&lang=js"
import style0 from "./FeedContentNewRegistration.vue?vue&type=style&index=0&id=6ae8273f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae8273f",
  null
  
)

export default component.exports